import React from 'react'
import s from './GeoentityBlockMenu.less'
import classNames from 'classnames'

export const MenuSectionLine = ({ description, value }) => {
  return (
    <li className={classNames(s.sectionLine, value && s.sectionWithValue)}>
      <div className={s.sectionLineDescription}>{description}</div>
      {value && <div className={s.sectionLineValue}>{value}</div>}
    </li>
  )
}

export const MenuSection = ({ title, items }) => {
  return (
    <li className={s.section}>
      {title && <div className={s.sectionTitle}>{title}</div>}
      <ul>
        {items.map((item, idx) => (
          <MenuSectionLine key={idx} {...item} />
        ))}
      </ul>
    </li>
  )
}

export default function GeoentityBlockMenu(props) {
  const { data } = props

  return (
    <div>
      <ul>
        {data.sections.map((section, idx) => (
          <MenuSection key={idx} {...section} />
        ))}
      </ul>
    </div>
  )
}
